import { BUBBLETAP_TEL } from '@repo/constants';

import * as Styled from '../../policy.styled';

export default function PrivacyPolicyZh() {
  return (
    <Styled.MainWrapper>
      <h3>BubbleTap 個人資料使用告知事項</h3>
      <p>第1條 什麼是個人資料使用告知事項？</p>
      <ol>
        ① 蒐集個人資料
        <br />
        BubbleTap Corp. (以下簡稱「本公司」)
        十分重視使用者的個人資料。我們承諾，使用者在使用公司提供的Tingle、獎勵等服務（以下簡稱「服務」）時，在線上向公司提供的個人資料將獲得妥善保護。為此，公司恪守《個人資料保護法》、《通訊保障及監察法》、《電信法》及《有關資訊通信網路利用促進及資訊保護法》等資訊通訊服務提供者必須遵守的相關個人資料保護法規。
        <br />
        <br />
        為提供服務，本公司將蒐集以下各項最基本的個人資料。所有使用者皆可使用公司提供的服務，而註冊會員後則可享受更多元的服務。本公司在蒐集使用者個人資料時，必定會事先告知並徵得使用者同意。本公司將蒐集以下各項最基本的個人資料，且未經使用者同意，不會蒐集任何敏感資訊。
        <br />
        <br />- 必填資訊：為實現該服務本質功能所必需的資訊。
        <br />- 選填資訊：為提供更專業化服務而額外蒐集的資訊。
        <br />
        <br />
        <li>
          Tingle、獎勵
          <ol>
            <li>必填：社群ID、ID</li>
            <li>選填：電子郵件地址、個人檔案相片、社群登入管道、暱稱</li>
          </ol>
        </li>
        <li>
          尋找帳號資訊
          <ol>
            <li>必填：社群ID、ID、電子郵件地址</li>
          </ol>
        </li>
        <li>
          支付及使用付費服務
          <ol>
            <li>必填：結帳時間、付款方式、付款商店、結帳金額、付款貨幣、付款 IP 、Google / Apple付款ID</li>
          </ol>
        </li>
        <li>
          Tingle 獎勵計畫
          <ol>
            <li>必填：社群ID、ID、姓名、身分證字號、收款人、銀行名、銀行帳號、如產生收益，則必須提供身分證字號</li>
          </ol>
        </li>
        <li>
          內容（參照服務條款第2條第2項）使用
          <ol>
            <li>必填：使用內容、使用時間、購買時間</li>
          </ol>
        </li>
        <li>
          販賣處個人賣家
          <ol>
            <li>
              必填：社群ID、ID、姓名、電子郵件地址、電話號碼、若為未成年賣家，需提供法定代理人的資訊（姓名、與賣家的關係、出生年月日、地址、電話號碼、電子郵件地址、身分證影本、親屬關係證明文件）、如產生收益，則必須提供身分證字號、銀行資訊（收款人、銀行名、銀行帳號）
            </li>
          </ol>
        </li>{' '}
        <li>
          販賣處個人/法人企業
          <ol>
            <li>
              必填：社群ID、ID、姓名、電子郵件地址、法人代表、電話號碼、事務所地址、負責人姓名 / 電話號碼 /
              電子郵件地址、銀行資訊（收款人、銀行名、銀行帳號）、提交文件（登記證明文件、法人印鑑證明書、法人代表存摺封面影本）
            </li>
          </ol>
        </li>
        <li>
          徵選
          <ol>
            <li>
              必填：暱稱或 ID 、電話號碼（滿 14
              歲以上）、（新增限制級內容時）實名認證資訊（姓名、出生年月日、性別、電子郵件地址、銀行帳號、本國人/外國人資訊、手機號碼、電信業者資訊、加密的個人識別資訊（PII））
            </li>
          </ol>
        </li>
        <li>
          實名認證
          <ol>
            <li>
              必填：
              電話號碼、本名、出生年月日、性別、本國人/外國人資訊、電信業者資訊、加密的個人識別資訊（PII）、重複註冊確認資訊（DI）
            </li>
          </ol>
        </li>
        <li>
          參與活動及中選
          <ol>
            <li>必填：姓名、地址、電話號碼、電子郵件地址、身分證號碼</li>
          </ol>
        </li>
        <li>
          客服中心
          <ol>
            <li>必填：電話號碼、社群ID、ID、姓名、電子郵件地址</li>
          </ol>
        </li>
      </ol>
      <ol>
        ② 在服務使用過程中自動產生或搜集的資訊
        <br />
        終端裝置資訊（型號名稱、裝置 ID、MAC 位址、作業系統）、IP
        位址、Cookie、連線記錄、不當使用記錄、服務使用記錄等資訊可能會被自動產生及蒐集。
        <br />
        <br />
        ③ 個人資料的蒐集方法
        <br />
        在蒐集個人資料時，我們必定會事先告知使用者該事實並徵求同意，並透過以下方式蒐集個人資料。
        <ol>
          <li>使用者在註冊會員和使用服務的過程中，同意公司蒐集個人資料時。</li>
          <li>公司透過其營運的社群媒體帳號，從該社群媒體公司獲取個人資料時。</li>
          <li>從合作服務或團體等處獲得個人資料時。</li>
          <li>透過網頁、電子郵件、傳真或電話向客服中心諮詢時。</li>
          <li>參與遠距或實體舉辦的活動時。</li>
        </ol>
      </ol>
      <p>第2條 個人資料使用</p>
      本公司僅將使用者的個人資料用於以下目的，若變更用途，將會事先徵求使用者的同意。
      <br />
      <br />
      ① 會員身分識別 / 確認加入會員意願、預防不當使用、本人身分確認及認證、處理客訴、紛爭調解。
      <br />
      ② 提供活動紀錄通知功能。
      <br />
      ③ 利用人口統計學上的特性及推測使用者感興趣的項目、喜好及傾向，提供客製化的內容推薦及作為行銷用途。
      <br />
      ④ 新服務開發及提供使用者客製化服務、提供多樣化的服務、處理諮詢事項或客訴、傳達公告事項。
      <br />
      ⑤ 使用付費或獎勵服務時，為傳送內容、結算費用、進行本人身分驗證、年齡驗證及帳戶驗證。
      <br />
      ⑥ 預防及制裁妨礙服務順利運作的行為（包括盜用帳號及不當使用行為等）。
      <br />
      ⑦ 確認參與活動、作為行銷及廣告用途。
      <br />
      ⑧ 服務使用紀錄、使用頻率及服務使用統計、建構隱私保護層面的服務環境、提供客製化/個人化服務、作為服務改善用途。
      <br />
      ⑨ 發生駭客攻擊、詐騙等相關事件時進行調查，或因應其他法令上的義務，在接獲正當且合法的調查要求時，提供相關資料。
      <br />
      <p>第3條 個人資料的保留及提供</p>
      ① ①
      在使用者要求退出會員前，或者個人資料的蒐集與利用目的達成前，將保留資料；使用者退出會員或前述目的達成後，將立即刪除資料。
      <br />② 依據公司的個人資料使用告知事項，在下列事由下，即使您退出會員，您的資料仍會在所載明的期間內保留。
      <br />
      <br />
      <ol>
        <li>
          服務使用相關個人資料（登入紀錄）
          <ol>
            <li>保留依據：韓國《通訊保障及監察法》</li>
            <li>保留期間：3個月</li>
          </ol>
        </li>
        <li>
          為了防止重複註冊或退出會員而保留的資訊
          <ol>
            若會員重複退出後再次註冊，或任意終止會員資格等，可能會有不當利用公司服務、非法獲取活動優惠、或盜用他人名義等疑慮。為了防止這類行為，會員退出後，我們會將您的會員資訊保留
            1 個月。
            <li>保留依據： 公司內部方針（防止再次註冊、任意終止等不當利用）</li>
            <li>保留期限： 1 個月</li>
          </ol>
        </li>
      </ol>
      <br />
      ③ 您有權拒絕提供個人資料，但若拒絕，則無法使用本服務。
      <br />
      ④
      我們不會將您的個人資訊提供給第三方，但以下情況除外：已獲得您的個別同意、法律另有規定、您或您的法定代理人處於無法表達意願，或因地址不明等原因而無法事先取得同意的情況，且情況緊急，經判斷為維護您或第三方的生命、身體、財產等重大利益所必需。若因服務串接而需向第三方提供個人資訊時，我們將在本條款中註明業者名稱、目的、提供項目以及個人資料的保留與使用期限。
      <br />
      <br />
      此外，為了提供服務，我們已將以下業務委託給外部廠商，並會對受託廠商進行管理及監督，確保其遵守相關法令。根據韓國《個人資料保護法》第
      26
      條規定，我們在簽訂委託契約時，會以書面明訂以下事項：禁止將個資用於委託業務目的以外之用途、應採取技術性及管理性保護措施、限制再委託、對受託廠商的管理與監督，以及損害賠償等責任歸屬。
      {/* <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>제공받는 업체명</th>
              <th>목적</th>
              <th>제공 항목</th>
              <th>개인정보 보유 및 이용기간</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>a</td>
              <td>b </td>
              <td>c</td>
              <td>d</td>
            </tr>
            <tr>
              <td>e</td>
              <td>f</td>
              <td>g</td>
              <td>h</td>
            </tr>
          </tbody>
        </table>
      </div> */}
      <div className="table-wrapper">
        <table>
          <colgroup>
            <col style={{ width: '50%' }}></col>
            <col style={{ width: '50%' }}></col>
          </colgroup>
          <thead>
            <tr>
              <th>韓國受託廠商</th>
              <th>委託業務內容</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Kakao Corp.</td>
              <td>管理基礎設施，以提供及分析服務</td>
            </tr>
            <tr>
              <td>ADENA SOFTWARE CO., LTD.</td>
              <td>
                服務開發及維護
                <br />
                系統營運及管理
                <br />
                資料儲存
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="table-wrapper">
        <table>
          <colgroup>
            <col style={{ width: '50%' }}></col>
            <col style={{ width: '50%' }}></col>
          </colgroup>
          <thead>
            <tr>
              <th>國外受託廠商</th>
              <th>委託業務內容</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Amazon Web Service, Inc</td>
              <td>管理基礎設施，以提供及分析服務</td>
            </tr>
            <tr>
              <td>Alphabet Inc.</td>
              <td>管理基礎設施，以提供及分析服務</td>
            </tr>
            <tr>
              <td>Meta Platforms Inc.</td>
              <td>管理基礎設施，以提供及分析服務</td>
            </tr>
            <tr>
              <td>Apple Inc.</td>
              <td>管理基礎設施，以提供及分析服務</td>
            </tr>
            <tr>
              <td>Anthropic PBC</td>
              <td>管理基礎設施，以提供及分析服務</td>
            </tr>
            <tr>
              <td>OpenAi Inc.</td>
              <td>管理基礎設施，以提供及分析服務</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>第4條 資料主體的權利、義務及行使方式</p>
      作為個人資料主體，使用者可行使以下權利。
      <br />
      <br />
      <ol>
        ① 使用者可隨時向本公司行使查閱、要求更正錯誤、刪除、停止處理等個人資料相關權利。
        <br />
        <br />
        ② 使用者可透過書面、電子郵件、傳真等方式，依據韓國《個人資料保護法》施行細則附表第 8
        號規定的格式，向本公司行使上述權利。本公司將會立即處理。
        <br />
        <br />
        ③ 使用者可透過法定代理人或受託人等代理人行使第 ① 項的權利。此時，需提交依據韓國《個人資料保護法》施行細則附表第
        11 號規定的委託書。
        <br />
        <br />
        ④ 針對使用者的權利行使（查閱、更正、刪除、停止處理等要求），本公司會確認提出要求者是否為本人或合法代理人。
        <br />
        <br />
        ⑤
        若使用者或使用者的法定代理人要求更正個人資料中的錯誤，本公司在完成更正或刪除前，不會使用或提供相關個人資料。此外，我們將會立即通知第三方，以確保錯誤的個人資料得到更正。
        <br />
        <br />
        ⑥
        若個人資料經使用者或使用者的法定代理人要求終止或刪除，本公司會依照第3條「個人資訊的保留及使用期限」之規定進行處理，並採取措施以防止其被用於其他用途。
        <br />
        <br />
        ⑦ 根據韓國《個人資料保護法》第 35 條第 5 項及第 37 條第 2
        項規定，使用者查閱及要求停止處理個人資料的權利可能會受到限制。
        <br />
        <br />
        ⑧ 若使用者或使用者的法定代理人要求更正或刪除個人資訊，但該資訊依其他法令規定必須蒐集，則無法要求刪除。
        <br />
        <br />⑨ 使用者不得違反《個人資料保護法》等相關法令，侵犯本公司所處理的使用者本人或他人的個人資料及隱私權。
      </ol>
      <p>第5條 個人資料銷毀</p>
      個人資料在達到蒐集及使用目的後，會立即以無法還原的方式銷毀。此外，依據「個人資訊有效期限制度」，對於一年內未使用服務的會員，其個人資料將另外獨立保管；而獨立保管的個人資料將在保管四年後，立即銷毀。
      <br />
      <br />
      此外，根據法令規定，必須保存一定期限的個人資料及相關法令詳見下表。
      <div className="table-wrapper">
        <table>
          <colgroup>
            <col style={{ width: '33%' }}></col>
            <col style={{ width: '33%' }}></col>
            <col style={{ width: '33%' }}></col>
          </colgroup>
          <thead>
            <tr>
              <th>保留資訊</th>
              <th>保留原因</th>
              <th>保留期間</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>有關契約或取消申請等的記錄</td>
              <td>
                電子商務等
                <br />
                消費者保護相關法律
              </td>
              <td>5年</td>
            </tr>
            <tr>
              <td>有關消費者不滿或爭議處理的記錄</td>
              <td>
                電子商務等
                <br />
                消費者保護相關法律
              </td>
              <td>5年</td>
            </tr>
            <tr>
              <td>有關消費者不滿或爭議處理的記錄</td>
              <td>
                電子商務等
                <br />
                消費者保護相關法律
              </td>
              <td>3年</td>
            </tr>
            <tr>
              <td>有關標示/廣告的記錄</td>
              <td>
                電子商務等
                <br />
                消費者保護相關法律
              </td>
              <td>6個月</td>
            </tr>
            <tr>
              <td>稅法規定的所有交易帳簿及憑證</td>
              <td>《國稅基本法》</td>
              <td>5年</td>
            </tr>
            <tr>
              <td>有關服務使用的登入記錄</td>
              <td>韓國《通訊保障及監察法》</td>
              <td>3個月</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>第6條 其他</p>
      ① 您可以隨時查詢或修改您的個人資訊，也可以要求撤回蒐集和使用的同意或取消會員資格。
      <br />
      <br />
      ② 對於未滿 14
      歲兒童的個人資料，若法定代理人提出要求，我們會保障其法律上的權利（如查詢、修改、刪除兒童個人資料，以及要求暫停處理個人資訊的權利）。
      <br />
      <br />
      <ol>
        ③ 我們的網路服務會設置並使用 Cookie（儲存及隨時讀取顧客資訊的工具）。
        <li>
          使用目的
          <ol>
            <li>
              Cookie 是由網站伺服器傳送給使用者瀏覽器的一個非常小的文字檔，會儲存在使用者的硬碟中。公司會利用 Cookie
              來儲存和隨時讀取使用者的資訊，以便提供個人化和客製化的服務。此外，Cookie
              也會被用於提供最佳化的廣告等客製化資訊，例如分析使用者的網站瀏覽記錄和使用模式。
            </li>
          </ol>
        </li>
        <li>
          拒絕收集Cookie
          <ol>
            <li>
              Cookie 中不會儲存姓名、手機號碼等可辨識個人身分的資訊，且使用者對於 Cookie 的安裝擁有選擇權。可透過第 6
              條第 3 項第 3 款的方法拒絕安裝 Cookie，但若拒絕，可能會導致網站使用不便，並難以使用部分需要登入的服務。
            </li>
          </ol>
        </li>
        <li>
          拒絕收集Cookie辦法
          <ol>
            <li>Internet Explorer: [設定] → [網際網路選項] → [個人資料] → [高級]</li>
            <li>Chrome: [設定] → [隱私權與安全性] → [網站設定] → [第三方 Cookie]</li>
            <li>Edge: [設定] → [Cookie 與其他網站資料] → [Cookie 與其他網站資料]</li>
            <li>Safari: [設定] → [APP] → [阻擋Cookie]</li>
          </ol>
        </li>
      </ol>
      <ol>
        ④ 本公司可能會收集使用者的 ADID/IDFA
        <br />
        <br />
        <li>
          收集目的
          <ol>
            <li>
              AADID/IDFA
              是行動應用程式使用者的廣告識別碼，主要用於衡量和蒐集數據，以便為使用者提供客製化的服務或更優質的廣告體驗。
            </li>
          </ol>
        </li>
        <li>
          拒絕辦法
          <ol>
            <li>Android: [設定] → [Google(Google設定)] → [廣告] → [廣告隱私權]</li>
            <li>iOS: [設定] → [隱私權] → [廣告] → [限制廣告追蹤]</li>
          </ol>
        </li>
      </ol>
      <ol>
        ⑤ 本公司為保護使用者珍貴的個人資料，正在進行以下努力。
        <li>本公司透過加密的通訊途徑傳輸使用者的個人資料，並對密碼等重要資訊進行加密儲存。</li>
        <li>
          為了防止使用者的個人資料因駭客攻擊或電腦病毒等原因而外洩或受損，本公司將系統安裝在外部存取受到控制的區域。我們也設置了可偵測和阻擋駭客入侵的系統，並進行
          24
          小時監控；同時安裝防毒軟體，努力確保系統不會受到最新的惡意程式或病毒感染。此外，我們持續研究新的駭客攻擊與安全技術並應用於服務中。
        </li>
        <li>
          本公司將處理個人資料的員工數減至最少。同時，我們針對個人資料儲存的資料庫系統和處理個人資料的系統，建立了一套關於密碼建立、變更以及存取權限的系統性標準，並持續進行審核。
        </li>
        <li>我們對所有處理個人資料的員工進行定期培訓，使其了解個人資料保護的義務和安全措施。</li>
        <li>
          本公司為了保護個人資料，會定期進行內部審核。此外，我們也會保管與管理登入個人資料處理系統的記錄，並使用安全功能以防登入記錄被偽造、篡改、盜取或遺失。
        </li>
      </ol>
      ⑥ 若您對個人資料保護有任何疑問，請透過以下聯絡方式洽詢。
      <div className="table-wrapper">
        <table>
          <colgroup>
            <col style={{ width: '33%' }}></col>
            <col style={{ width: '33%' }}></col>
            <col style={{ width: '33%' }}></col>
          </colgroup>
          <thead>
            <tr>
              <th>個人資料保護負責人</th>
              <th>歸屬</th>
              <th>聯絡方式</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Hyunho Kim</td>
              <td>BubbleTap Team</td>
              <td>
                <span className="tel">{BUBBLETAP_TEL}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      此外，若您的個人資料遭到侵害，需要進行申報或諮詢，可以向以下機構尋求協助。
      <div className="table-wrapper">
        <table>
          <colgroup>
            <col style={{ width: '33%' }}></col>
            <col style={{ width: '33%' }}></col>
            <col style={{ width: '33%' }}></col>
          </colgroup>
          <thead>
            <tr>
              <th>機構</th>
              <th>聯絡方式</th>
              <th>網址</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>個人資料侵害申訴中心</td>
              <td>118</td>
              <td>https://privacy.kisa.or.kr</td>
            </tr>
            <tr>
              <td>最高檢察署查緝網路犯罪中心</td>
              <td>1301</td>
              <td>https://spo.go.kr</td>
            </tr>
            <tr>
              <td>警察廳網路安全局</td>
              <td>182</td>
              <td>https://ecrm.police.go.kr</td>
            </tr>
            <tr>
              <td>個人資料爭議處理委員會</td>
              <td>1833-6972</td>
              <td>https://www.kopico.go.kr</td>
            </tr>
          </tbody>
        </table>
      </div>
      ⑦ 個人資料保護政策的變更
      <br />
      <br />
      為反映法律或服務內容的變動，本公司可能會修訂個人資料使用告知事項。當政策變更時，我們會將變更內容公告於網頁上，新政策將於公告日起七天後生效。但若變更涉及使用者權益的重大事項（例如：蒐集之個人資料項目或使用目的變更），我們將會於變更生效日至少三十天前進行預告。
      <br />
      <br />
      {/* 공고일자: 2022년 5월 xx일 <br />
      시행일자: 2022년 5월 xx일 */}
    </Styled.MainWrapper>
  );
}
